module.exports = __webpack_public_path__ + "static/doctor-8a8ee50004769dda391e314ea87e0881.png";